import React from 'react';
import {
    Box,
    Button,
    CircularProgress,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import {
    CalendarTodayRounded,
    FileDownloadRounded,
    FilterAltRounded,
} from "@mui/icons-material";

const _ChargeTransactionFilters = ({
    ticketStatus,
    setTicketStatus,
    setFromDate,
    setToDate,
    onApplyFilter,
    onExportExcel,
    exporting,
}) => {
    return (
        <Box
            sx={{
                p: { xs: 2, sm: 2.5 },
                borderBottom: '1px solid',
                borderColor: 'divider',
                bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.02)' : 'rgba(0, 0, 0, 0.015)'
            }}
        >
            <Grid container spacing={2} alignItems="center">
                {/* Date Picker */}
                <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <CalendarTodayRounded sx={{ fontSize: 18, color: 'text.secondary' }} />
                        <DatePicker
                            calendar={persian}
                            locale={persian_fa}
                            numberOfMonths={2}
                            range
                            placeholder="فیلتر بازه زمانی (از - تا)..."
                            calendarPosition="bottom-right"
                            inputClass="custom-date-picker-input"
                            onChange={(selectedDates) => {
                                if (selectedDates && selectedDates.length === 2) {
                                    setFromDate(selectedDates[0]?.toDate());
                                    setToDate(selectedDates[1]?.toDate());
                                } else if (!selectedDates || selectedDates.length === 0) {
                                    setFromDate(null);
                                    setToDate(null);
                                }
                            }}
                            style={{
                                width: '100%',
                                height: '40px',
                                borderRadius: '10px',
                                border: '1px solid #ddd',
                                padding: '0 12px',
                                fontSize: '0.88rem',
                                fontFamily: 'inherit',
                                textAlign: 'right'
                            }}
                        />
                    </Box>
                </Grid>

                {/* Status Select */}
                <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                    <FormControl fullWidth size="small">
                        <InputLabel id="trans-status-label">وضعیت فاکتور</InputLabel>
                        <Select
                            labelId="trans-status-label"
                            value={ticketStatus}
                            onChange={(e) => setTicketStatus(e.target.value)}
                            label="وضعیت فاکتور"
                            sx={{ borderRadius: 2.5 }}
                        >
                            <MenuItem value="">همه وضعیت‌ها</MenuItem>
                            <MenuItem value="COMPLETED">تکمیل شده</MenuItem>
                            <MenuItem value="REFUNDED">استرداد شده</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>

                {/* Search Button */}
                <Grid size={{ xs: 6, sm: 6, md: 2 }}>
                    <Button
                        fullWidth
                        variant="contained"
                        size="small"
                        startIcon={<FilterAltRounded sx={{ ml: 0.8 }} />}
                        onClick={onApplyFilter}
                        sx={{
                            py: 1,
                            borderRadius: 2.5,
                            fontWeight: 700,
                            boxShadow: '0 4px 12px rgba(28, 139, 156, 0.2)'
                        }}
                    >
                        اعمال فیلتر
                    </Button>
                </Grid>

                {/* Excel Export Button */}
                <Grid size={{ xs: 6, sm: 6, md: 3 }} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        variant="outlined"
                        size="small"
                        disabled={exporting}
                        startIcon={exporting ? <CircularProgress size={16} /> : <FileDownloadRounded sx={{ ml: 0.8 }} />}
                        onClick={onExportExcel}
                        sx={{
                            py: 1,
                            px: 2,
                            borderRadius: 2.5,
                            fontWeight: 700,
                            borderColor: 'divider',
                            color: 'text.primary',
                            bgcolor: 'background.paper'
                        }}
                    >
                        خروجی اکسل
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
};

export default _ChargeTransactionFilters;
